module.exports = __webpack_public_path__ + "static/media/yoga-retreat-banner-mobile.62a89d9d.jpg";